/*
 * @Author: huangzq
 * @Date: 2020-04-13 20:23:04
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-06-08 17:47:51
 * @Desc: 课程编辑or新建对应的表单数据
*/

import TagListShowNew from '@/components/tag-list-show-new/index.vue'

import ReadonlySpan from './readonly-span.vue'
import CourseListMaterial from './course-list-material'

export const FormGlobalConfig = {
  labelWidth: '90px'

}

export const FormRules = {
  // 'name.value': [
  //   { required: true, message: '请输入课程名称', trigger: 'blur' }
  // ]
}

export const FormSchema = {
  name: {
    // 当前字段类型
    type: 'string',
    // 当前字段的值，v-model使用
    value: '',
    // 当前字段的默认值，重置时使用
    defaultValue: '',
    // el-form-item的包含的组件，完全自定义的
    ui: {
      label: '课程名称：',
      placeholder: '请输入名称',
      // 组件名
      widget: ReadonlySpan,
      // 组件配置
      widgetConfig: {
      }
    }
  },
  showTags: {
    type: 'Array',
    value: [],
    defaultValue: [],
    ui: {
      label: '课程标签：',
      placeholder: '选择标签（多选）',
      widget: TagListShowNew,
      widgetConfig: {
        limit: 5,
        style: {
          display: 'flex',
          height: '32px'
        }
      }
    }
  },
  description: {
    type: 'string',
    value: '',
    defaultValue: '',
    ui: {
      label: '课程说明：',
      placeholder: '请输入课程说明',
      widget: ReadonlySpan,
      widgetConfig: {
      }
    }
  },
  courseWares: {
    type: 'Array',
    value: [],
    defaultValue: [],
    ui: {
      label: '课件：',
      widget: CourseListMaterial,
      widgetConfig: {
        // 是否只是展示，不可编辑状态
        readonly: true
      }
    }
  }
}
